module.exports = __webpack_public_path__ + "media/images/pic/brodno/join-us-8bacf9be223bc1d92d98f3a78e46f13d.jpg";